import { IGetProfileAction } from './profile.interface';

export enum GetProfileTypes {
	GET_PROFILE = 'GET_PROFILE',
}

export type GetProfileAction = IGetProfileAction;
